export const minted: Record<
  "ALL" | "YEAR" | "MONTH" | "WEEK" | "DAY",
  number[]
> = {
  "DAY": [0.49, 0.49, 0.49, 0.66],
  "WEEK": [0.47, 0.47, 0.49, 0.49, 0.49, 0.66],
  "MONTH": [0.45, 0.45, 0.45, 0.45, 0.47, 0.47, 0.49, 0.49, 0.49, 0.66],
  "YEAR": [
    0.2,
    0.3,
    0.3,
    0.4,
    0.45,
    0.45,
    0.45,
    0.45,
    0.47,
    0.47,
    0.49,
    0.49,
    0.49,
    0.66,
  ],
  "ALL": [
    0.2,
    0.3,
    0.3,
    0.4,
    0.45,
    0.45,
    0.45,
    0.45,
    0.47,
    0.47,
    0.49,
    0.49,
    0.49,
    0.66,
  ],
}
